import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
export interface Props {
  title: {
    index: number;
    content: string;
  } | string;
}
const Title = styled('span')(({
  theme: {
    palette
  }
}) => ({
  display: 'inline-block',
  position: 'relative',
  '&::after': {
    content: '""',
    height: 1,
    display: 'inline-block',
    width: '100%',
    position: 'absolute',
    left: 0,
    bottom: 0
  },
  '&.gradient1': {
    '&::after': {
      background: palette.brand.gradient.violetBlue
    }
  },
  '&.gradient2': {
    '&::after': {
      background: palette.brand.gradient.pinkViolet
    }
  }
}));
const GRADIENT_CLASSNAMES = ['gradient1', 'gradient2'];
export default function HeaderDropDownOverTitle(t0) {
  const $ = _c(6);
  const {
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = typeof title === "string" ? {
      index: 0,
      content: title
    } : title;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    index,
    content: titleStr
  } = t1;
  const t2 = GRADIENT_CLASSNAMES[index % 2];
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      ml: 2
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2 || $[4] !== titleStr) {
    t4 = <Typography variant="bodySmall" component={Title} className={t2} sx={t3}>{titleStr}</Typography>;
    $[3] = t2;
    $[4] = titleStr;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}